const asyncTimeout = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export default asyncTimeout;
